import React from 'react';
import classnames from 'classnames';
import { Layout } from 'components/layout';
import { Container } from 'components/container';
import { BackButton } from 'components/back-button';
import { routesNO, RouteList, routesEN } from 'api/routes';
import { SEO } from 'components/seo';
import styles from './account-subpage.module.scss';
import { returnRoutesForLanguage } from 'services/language-service';
import { useSelector } from 'react-redux';
import { Language } from '_types/language';
import { languageSelector } from 'store-modules/app-settings';
import { useNavigate } from 'react-router-dom';

interface Props {
    pageClassName?: string;
    bgClassName?: string;
    title: string;
    pageTitle: string;
    children: React.ReactNode;
    withHeaderSpace?: boolean;
    customBackRoute?: string;
}

const routeObj: { name: Language; routes: RouteList }[] = [
    {
        name: 'nb',
        routes: routesNO,
    },
    {
        name: 'en',
        routes: routesEN,
    },
];

const AccountSubpage: React.FC<Props> = ({
    pageClassName,
    bgClassName,
    pageTitle,
    title,
    children,
    withHeaderSpace,
    customBackRoute,
}: Props) => {
    const navigate = useNavigate();
    const language: Language = useSelector(languageSelector);
    const routes = returnRoutesForLanguage(language, routeObj);
    const navigateToAccountPage = (): void =>
        customBackRoute
            ? navigate(customBackRoute)
            : navigate(routes.account.index);

    return (
        <Layout
            routes={routes}
            language={language}
            pageClassName={classnames(styles.page, pageClassName)}
            withHeaderSpace={withHeaderSpace}
        >
            <div className={classnames(styles.bg, bgClassName)} />
            <SEO title={pageTitle} />
            <Container className={styles.container}>
                <BackButton
                    language={language}
                    className={styles.backButton}
                    clickHandler={navigateToAccountPage}
                />
                <h1 className={styles.title}>{title}</h1>
                {children}
            </Container>
        </Layout>
    );
};

export default AccountSubpage;
